import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "position-relative" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_loader = _resolveComponent("g-loader");
    const _component_g_dynamic_html = _resolveComponent("g-dynamic-html");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_g_loader, { key: 0 }))
            : _createCommentVNode("", true),
        (_ctx.contentHtml)
            ? (_openBlock(), _createBlock(_component_g_dynamic_html, {
                key: 1,
                template: _ctx.contentHtml,
                templateProps: { dataObject: _ctx.dataObject }
            }, null, 8, ["template", "templateProps"]))
            : _createCommentVNode("", true)
    ]));
}
